export default "__VITE_ASSET__B79auOPy__"